<template>
  <div class="maincont" id="detail_air_conditioner_detail">
    <div id="charts">
      <div class="ef--inner">
        <div id="air_conditioner_detail">
          <h2>空調自動制御詳細</h2>
          <a
            href="javascript:void(0);"
            class="dlbtn"
            @click="downloadDialog = true"
          >帳票ダウンロード</a>

          <p class="subttl">空調自動制御詳細</p>

          <div class="menu_info">
            <dl class="date_time">
              <dd><span>{{ getYYYY }}年 {{ getMM }}月 {{ getDD }}日 {{ getStartTime }}～{{ getEndTime }}</span></dd>
            </dl>

            <dl class="power_info">
              <dt>空調使用電力：</dt>
              <dd><span>{{ this.detailData.used_power }}</span>kW</dd>
            </dl>

            <div class="status_info" v-bind:class="'level' + this.getControlLevel()">
              <span v-if="this.detailData.control_status == 0">未制御</span>
              <span v-if="this.detailData.control_status == 1">制御中 (限界制御)</span>
              <span v-if="this.detailData.control_status == 2">制御中 (注意制御)</span>
            </div>
          </div>

          <div class="detail_info">
            <table id="detail_info"></table>
          </div>

          <div class="chart_info">
            <div class="chart_header">
              <p class="label_title">空調機使用電力 (kW)</p>
              <div id="legend_info" class="legend"></div>
              <p class="label_left">(kW)</p>
            </div>
            <div class="chart_body">
              <canvas id="detail_canvas"></canvas>
              <p class="label_right">(分)</p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <download-dialog
      @close="downloadDialog=false"
      v-if="downloadDialog"
      :account="this.$store.state.childID"
    ></download-dialog>

  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import Store from "../store";
import DownloadDialog from "../components/AirConditionerDetailDownloadDialog";

export default {
  name: "air_conditioner_detail",
  components: {
    DownloadDialog
  },
  data: function() {
    return {
      downloadDialog: false,
      detailChart: null,
      detailData: {
        start_datetime: "",
        end_datetime: "",
        control_status: 0,
        used_power: 0,
        parent_info: [],
        graph_info: {
          power_min: 0,
          power_max: 0,
          graph_data: []
        }
      }
    };
  },

  mounted: function() {
    this.getDetailData();
  },

  computed: {
    getYYYY: function() {
      return moment.utc(this.detailData.start_datetime, "YYYY/MM/DD HH:mm:ss").format("YYYY");
    },

    getMM: function() {
      return moment.utc(this.detailData.start_datetime, "YYYY/MM/DD HH:mm:ss").format("MM");
    },

    getDD: function() {
      return moment.utc(this.detailData.start_datetime, "YYYY/MM/DD HH:mm:ss").format("DD");
    },

    getStartTime: function() {
      return moment.utc(this.detailData.start_datetime, "YYYY/MM/DD HH:mm:ss").format("HH:mm");
    },

    getEndTime: function() {
      return moment.utc(this.detailData.end_datetime, "YYYY/MM/DD HH:mm:ss").format("HH:mm");
    }
  },

  methods: {
    getControlLevel: function() {
      let ret = 1;
      if (this.detailData.control_status == 1) {
        ret = 3;
      } else if (this.detailData.control_status == 2) {
        ret = 2;
      } else {
        ret = 1;
      }
      return ret;
    },

    setDetailInfo: function() {
      let titleIndex = 0;
      let childIndex = 0;
      let rowCount = 0;
      let innerHtml = "";
      let detailInfo = document.getElementById("detail_info");

      innerHtml += "<thead>";
      innerHtml += "<tr>";
      innerHtml += "<th style=\"width:10%; height:25px;\">親 機</th>";
      innerHtml += "<th style=\"width:10%; height:25px;\">空調電力</th>";
      innerHtml += "<th style=\"width:80%; height:25px;\" colspan=\"10\">子 機</th>";
      innerHtml += "</tr>";
      innerHtml += "</thead>";

      innerHtml += "<tbody>";
      for (let i = 0; i < this.detailData.parent_info.length; i++) {
        titleIndex = 0;
        childIndex = 0;
        rowCount = (Math.ceil(this.detailData.parent_info[i].child_info.length / 10) * 2);

        for (let j = 0; j < rowCount; j++) {
          innerHtml += "<tr>"
          if (j == 0) {
            innerHtml += ("<th rowspan=\"" + rowCount + "\">" + this.detailData.parent_info[i].device_id + "</th>");
            innerHtml += ("<td rowspan=\"" + rowCount + "\"><span>" + this.detailData.parent_info[i].used_power + "</span>kW</td>");
          }

          if (j % 2 == 0) {
            for (let k = 0; k < 10; k++, titleIndex++) {
              if (titleIndex < this.detailData.parent_info[i].child_info.length) {
                innerHtml += ("<th style=\"width:8%; height:25px;\">" + this.detailData.parent_info[i].child_info[titleIndex].device_id + "</th>");
              } else {
                innerHtml += ("<td style=\"width:8%; height:25px; border:none;\"></td>");
              }
            }
          } else {
            for (let k = 0; k < 10; k++, childIndex++) {
              if (childIndex < this.detailData.parent_info[i].child_info.length) {
                innerHtml += ("<td style=\"width:8%; height:25px;\"><span>" + this.detailData.parent_info[i].child_info[childIndex].used_power + "</span>kW</td>");
              } else {
                innerHtml += ("<td style=\"width:8%; height:25px; border:none;\"></td>");
              }
            }
          }
          innerHtml += "</tr>"
        }
      }
      innerHtml += "</tbody>";
      detailInfo.innerHTML = innerHtml;
    },

    getMaxKw: function() {
      let base = Math.ceil(this.detailData.graph_info.power_max * 1.2);
      let digit = base.toString().length;
      let round = 0;
      let ret = base;
      if (digit == 1) {
        ret = 10;
      } else if (digit == 2) {
        ret = Math.ceil(base / 10) * 10;
      } else {
        round = Math.ceil(base / (10 ** (digit - 2)));
        if (round % 10 == 0) {
          ret = Math.ceil(round * (10 ** (digit - 2)));
        } else if (round % 10 > 5) {
          ret = Math.ceil(round / 10) * (10 ** (digit - 1));
        } else {
          ret = (Math.floor(round / 10) + 0.5) * (10 ** (digit - 1));
        }
      }
      return ret;
    },

    setDetailGraph: function() {
      let dateList = [];
      let powerList = [];

      const self = this;

      for (let i = 0; i < this.detailData.graph_info.graph_data.length; i++) {
        dateList.push(this.detailData.graph_info.graph_data[i].date);
        powerList.push(this.detailData.graph_info.graph_data[i].used_power);
      }

      let minKw = this.detailData.graph_info.power_min;
      let maxKw = this.getMaxKw();
      let stepKw = maxKw / 10;

      let chartData = {
        labels: dateList,
        datasets: [
          {
            type: "line",
            label: "空調機使用電力",
            data: powerList,
            borderColor: "rgba(50,100,255,1.0)",
            fill: false,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };

      let chartOption = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(param) {
          let captionList = [];
          captionList.push('<ul>');
          for (let i = 0; i < param.data.datasets.length; i++) {
            captionList.push("<li><span>");
            captionList.push(param.data.datasets[i].label);
            captionList.push("</span></li>");
          }
          captionList.push("</ul>");
          return captionList.join("");
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              id: "y-axis-1",
              type: "linear",
              position: "left",
              ticks: {
                min: minKw,
                max: maxKw,
                stepSize: stepKw
              }
            }
          ]
        }
      };

      if (this.detailChart) {
        this.detailChart.destroy();
      }

      this.detailChart = new Chart(
        document.getElementById("detail_canvas").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: chartOption
        }
      );

      $("#legend_info").html(this.detailChart.generateLegend());

    },

    getDetailData: function() {
      this.$axios
        .get(`/srv/api/air_conditioner_detail_screen/${this.$store.state.childID}`,
              { withCredentials: true }
        )
        .then(response => {
          this.detailData = response.data;
          this.setDetailInfo();
          this.setDetailGraph();
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
